import React from "react";
import { Navbar, NavDropdown, Nav, Modal, Button } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import {
  removeLoginCookies,
  getCookie,
  getAccess,
} from "../../../Utils/Helper";

export default function Header() {
  var navigate = useNavigate();
  let accessInfo = getCookie("access-levels");
  const hotelAccess =
    accessInfo && accessInfo.length > 0
      ? accessInfo.filter((access) => {
          return access.ModuleName.toLowerCase() === "hotel";
        })
      : [];
  const regionAccess =
    accessInfo && accessInfo.length > 0
      ? accessInfo.filter((access) => {
          return access.ModuleName.toLowerCase() === "region";
        })
      : [];
  const ewsAccess =
    accessInfo && accessInfo.length > 0
      ? accessInfo.filter((access) => {
          return access.ModuleName.toLowerCase() === "ews";
        })
      : [];
  const singleHotelView = getAccess("Hotel", "/SingleHotelView");
  const bulkBasicInformation = getAccess("Hotel", "/BulkBasicInformation");
  const bulkDescription = getAccess("Hotel", "/BulkDescription");
  const bulkImages = getAccess("Hotel", "/BulkImages");
  const bulkReviews = getAccess("Hotel", "/BulkReviews");
  const bulkCreate = getAccess("Hotel", "/BulkCreate");
  const suplierCodeUpload = getAccess("Hotel", "/HotelSupplierCode");
  const regionCreate = getAccess("Region", "/RegionCreate");
  const singleRegionView = getAccess("Region", "/SingleRegionView");
  const landmark = getAccess("Region", "/Landmark");
  const regionSupplierCode = getAccess("Region", "/RegionSupplierCode");
  const canViewLogs = getAccess("Logs", "/EWS");

  const onClickNavLink = () => {};

  const handleLogout = () => {
    removeLoginCookies();
    navigate("/Login");
  };
  // const handleItemClick = (event, item) => {
  //   navigate("/SingleHotelEdit");
  // };
  return (
    <>
      <Navbar
        // collapseOnSelect
        expand="lg"
        className="navbar navbar-bg-1 navbar-expand-md navbar-dark"
      >
        <div className="container-fluid">
          <Navbar.Brand as={NavLink} to="Dashboard">
            <img
              src={require("../../../Assets/Images/Stuba-TopLogo.png")}
              alt="Logo"
              width="92"
              height="24"
            ></img>
          </Navbar.Brand>

          <>
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="header-menu mb-2 mb-md-0" id="navbarOptions">
                {hotelAccess.length > 0 && (
                  <NavDropdown
                    title={"Hotel"}
                    id="collasible-nav-dropdown"
                    className="ps-2 dropdown-menu-end dropdown-menu-arrow profile nav-profile_lable "
                  >
                    {singleHotelView && (
                      <NavDropdown.Item
                        as={NavLink}
                        // onClick={(e) => {
                        //   handleItemClick(e, "SingleHotelEdit");
                        // }}
                        to="SingleHotelEdit"
                        className="dropdown-item d-flex align-items-center"
                      >
                        Single Hotel Edit
                      </NavDropdown.Item>
                    )}
                    {bulkBasicInformation && (
                      <NavDropdown.Item
                        as={NavLink}
                        to="BulkBasicInformation"
                        className="dropdown-item d-flex align-items-center"
                      >
                        Bulk Basic Information
                      </NavDropdown.Item>
                    )}
                    {bulkDescription && (
                      <NavDropdown.Item
                        as={NavLink}
                        to="BulkDescription"
                        className="dropdown-item d-flex align-items-center"
                      >
                        Bulk Description
                      </NavDropdown.Item>
                    )}
                    {bulkImages && (
                      <NavDropdown.Item
                        as={NavLink}
                        to="BulkImages"
                        className="dropdown-item d-flex align-items-center"
                      >
                        Bulk Images
                      </NavDropdown.Item>
                    )}
                    {bulkReviews && (
                      <NavDropdown.Item
                        as={NavLink}
                        to="BulkReviews"
                        className="dropdown-item d-flex align-items-center"
                      >
                        Bulk Reviews
                      </NavDropdown.Item>
                    )}
                    {bulkCreate && (
                      <NavDropdown.Item
                        as={NavLink}
                        to="BulkCreate"
                        className="dropdown-item d-flex align-items-center"
                      >
                        Bulk Create
                      </NavDropdown.Item>
                    )}
                    {suplierCodeUpload && (
                      <NavDropdown.Item
                        as={NavLink}
                        to="HotelSupplierCode"
                        className="dropdown-item d-flex align-items-center"
                      >
                        Supplier Code Upload
                      </NavDropdown.Item>
                    )}
                  </NavDropdown>
                )}
                {regionAccess.length > 0 && (
                  <NavDropdown
                    title={"Region"}
                    id="collasible-nav-dropdown"
                    className="ps-2 dropdown-menu-end dropdown-menu-arrow profile nav-profile_lable "
                  >
                    {regionCreate && (
                      <NavDropdown.Item
                        as={NavLink}
                        to="RegionCreate"
                        className="dropdown-item d-flex align-items-center"
                      >
                        Create
                      </NavDropdown.Item>
                    )}
                    {singleRegionView && (
                      <NavDropdown.Item
                        as={NavLink}
                        to="SingleRegionEdit"
                        className="dropdown-item d-flex align-items-center"
                      >
                        Single Region Edit
                      </NavDropdown.Item>
                    )}
                    {landmark && (
                      <NavDropdown.Item
                        as={NavLink}
                        to="Landmark"
                        className="dropdown-item d-flex align-items-center"
                      >
                        Landmark
                      </NavDropdown.Item>
                    )}
                    {regionSupplierCode && (
                      <NavDropdown.Item
                        as={NavLink}
                        to="RegionSupplierCode"
                        className="dropdown-item d-flex align-items-center"
                      >
                        Supplier Code Upload
                      </NavDropdown.Item>
                    )}
                  </NavDropdown>
                )}
                {canViewLogs && (
                  <NavDropdown
                    title={"Logs"}
                    id="collasible-nav-dropdown"
                    className="ps-2 dropdown-menu-end dropdown-menu-arrow profile nav-profile_lable "
                  >
                    <NavDropdown.Item
                      as={NavLink}
                      to="EWSReports"
                      className="dropdown-item d-flex align-items-center"
                    >
                      EWS
                    </NavDropdown.Item>
                  </NavDropdown>
                )}
              </Nav>
              <div className="d-flex header-right-1" id="navBarUsers">
                <Nav className="header-nav header-right-2 ms-auto desktop-user-dropdown">
                  <Nav className="d-flex align-items-center">
                    <Nav.Item className="nav-item dropdown">
                      <span
                        className="nav-link nav-profile d-flex align-items-center pe-0"
                        // href="#"
                        data-bs-toggle="dropdown"
                      >
                        <svg
                          width="17"
                          height="20"
                          viewBox="0 0 17 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.7542 11.9999C14.9962 11.9999 16.003 13.0068 16.003 14.2488V14.8242C16.003 15.7185 15.6835 16.5833 15.1019 17.2627C13.5326 19.0962 11.1454 20.0011 8 20.0011C4.85414 20.0011 2.46812 19.0959 0.90182 17.2617C0.322059 16.5828 0.00354004 15.7193 0.00354004 14.8265V14.2488C0.00354004 13.0068 1.0104 11.9999 2.25242 11.9999H13.7542ZM13.7542 13.4999H2.25242C1.83882 13.4999 1.50354 13.8352 1.50354 14.2488V14.8265C1.50354 15.3622 1.69465 15.8802 2.04251 16.2876C3.29582 17.7553 5.26169 18.5011 8 18.5011C10.7383 18.5011 12.7059 17.7553 13.9624 16.2873C14.3113 15.8797 14.503 15.3608 14.503 14.8242V14.2488C14.503 13.8352 14.1678 13.4999 13.7542 13.4999ZM8 0.00463867C10.7614 0.00463867 13 2.24321 13 5.00464C13 7.76606 10.7614 10.0046 8 10.0046C5.23857 10.0046 3 7.76606 3 5.00464C3 2.24321 5.23857 0.00463867 8 0.00463867ZM8 1.50464C6.067 1.50464 4.5 3.07164 4.5 5.00464C4.5 6.93764 6.067 8.50464 8 8.50464C9.93299 8.50464 11.5 6.93764 11.5 5.00464C11.5 3.07164 9.93299 1.50464 8 1.50464Z"
                            fill="white"
                          />
                        </svg>
                        <NavDropdown
                          title={
                            "Hi " +
                            (getCookie("user-Fname")
                              ? getCookie("user-Fname")
                              : "")
                          }
                          id="collasible-nav-dropdown"
                          className="ps-2 dropdown-menu-end dropdown-menu-arrow profile nav-profile_lable"
                        >
                          <NavDropdown.Item
                            as={NavLink}
                            to="Dashboard"
                            className="dropdown-item d-flex align-items-center"
                          >
                            Dashboard
                          </NavDropdown.Item>
                          <NavDropdown.Item
                            onClick={handleLogout}
                            className="dropdown-item d-flex align-items-center"
                          >
                            Log Out
                          </NavDropdown.Item>
                        </NavDropdown>
                      </span>
                    </Nav.Item>
                  </Nav>
                </Nav>
              </div>
            </Navbar.Collapse>
          </>
        </div>
      </Navbar>
    </>
  );
}
